import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";

import { BiCalendarCheck } from "react-icons/bi";
import { AiFillCaretDown } from "react-icons/ai";
import { IoMdCreate } from "react-icons/io";
import moment from "moment";



import { makeStyles, Card, CardContent, Collapse, List, ListItem, ListItemText, ListItemAvatar, Avatar, ListItemSecondaryAction, IconButton, Button } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    //   marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },

}));


const DateCards = (props) => {
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location
  let { path, url } = useRouteMatch();
  const classes = useStyles();
  const [selected, setSelected] = React.useState({});

  const { onDelete, handleClickOpen } = props;

  // const handleClose = () => {
  //   setOpen(false);
  // };

  const handleExpandClick = (index) => {
    if (!selected[index]) {
      setSelected({ [index]: true });
    } else {
      setSelected({ [index]: false });
    }
  };

  const isExpanded = (index) => {
    return selected[index];
  };


  const onStart = (_conference) => {
    history.push(`${path}/conference`, _conference);
  }

  const deleteOne = (id) => {
    console.log(id)
    onDelete(id);
  };

  let filteredConferences = props.data.filter(conf => moment(conf.date).isSameOrAfter(moment(new Date()).format("YYYY-MM-DD")));

  // let filteredConferences = props.data.filter(conf => new Date(conf.date) > Date.now());
  //   filteredConferences = filteredConferences.sort((a, b ) => {
  //       return new Date(a.date).getTime() -
  //       new Date(b.date).getTime();
  //     });
      

  return (
    <Col className="conference-list-container">
      <Card className="dashboard-card" id="newConferencecCard">
        <List >
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <IoMdCreate />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              id="newConferencecCardText"
              primary="Add New Conference"
              className="header-font"
              // onClick={openAdd}
              onClick={handleClickOpen}
            />
          </ListItem>
        </List>
      </Card>
      
      {filteredConferences.map((dates, i) => {
        return (
          <Card className="dashboard-card" key={i} >
            <CardContent>
              <List>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <BiCalendarCheck />
                    </Avatar>
                  </ListItemAvatar>

                  <ListItemText primary={dates.label} secondary={moment(dates.date).format("MMM Do ") + ' at ' + moment(dates.time, "hh:mm:ss.sss").format("h:mm")} />

                  <ListItemSecondaryAction>
                    <IconButton edge="end"
                      className={clsx(classes.expand, {
                        [classes.expandOpen]: isExpanded(i),
                      })}
                      onClick={() => handleExpandClick(i)}
                      aria-expanded={isExpanded(i)}
                      aria-label="show more"
                    >
                      <AiFillCaretDown />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </CardContent>

            <Collapse in={isExpanded(i)} timeout="auto" unmountOnExit>
              {/* need to expand seed data to show full content here  */}
              <CardContent>
                <Row>
                  <Col className="conferenceCardDescrip">
                    {dates.description}
                  </Col>
                </Row>
                <Row>
                  <Col><Button
                    onClick={() => deleteOne(dates)}>
                    Delete</Button></Col>
                  <Col className="start-conference-button"><Button onClick={() => onStart(dates)}>Start Conference</Button> </Col>
                </Row>

              </CardContent>

            </Collapse>


          </Card >
        )
        // }
      })
      }
    </Col>
  )
};


export default DateCards;